module.exports = __webpack_public_path__ + "static/media/Oct8-F19.5a2c243d.png";